import { GeneralArea, GeneralUserVerificationRequirementDto, useRepositoryMutation } from '@mews-commander/data-access';
import { getDeviceFingerprintPayload } from '../../../ducks/actions';

export const useGetSignInInfo = () => {
    const { mutateAsync: getSignInInfo } = useRepositoryMutation('generalUsers', 'getSignInInfo');

    return async ({ nameOrEmail }: { nameOrEmail: string }) => {
        try {
            return getSignInInfo({
                userIdentifier: nameOrEmail,
                device: getDeviceFingerprintPayload(),
                application: GeneralArea.Commander,
                userVerification: GeneralUserVerificationRequirementDto.Preferred,
            });
            // eslint-disable-next-line @mews/no-empty-catch
        } catch (error) {
            // Mute errors from promise rejections in submit calls.
            // Mutation errors are handled in the mutation itself.
        }
    };
};
